import React, { Component } from 'react'
import { withStyles } from '@material-ui/styles'
import { CoverForm } from '../forms'
import { Dashboard } from '../layouts'

const styles = theme => ({
    //
})

class CoverNew extends Component {
    constructor(props) {
        super(props)
        
        this.state = {
            title: 'Ковер'
        }
    }

    render() {
        const { title } = this.state
        return (
            <Dashboard title={title}>
                <CoverForm 
                    path="covers"
                    method="post"
                    message="Амжилттай нэмэгдлээ"
                />
            </Dashboard>
        )
    }
}

export default withStyles(styles)(CoverNew)
